import {
  CLEAR_USAGE_SUMMARY_PAGE_STATE,
  SET_BROADBAND_ID,
  SET_SELECTED_DAILY_USAGE_MONTH,
  SET_SELECTED_SELECTED_PACKAGE_TYPE,
  SET_SELECTED_USAGE_PAGE_INDEX,
} from '../../const/actionTypes';
import { EPackageType } from '../../interfaces/packageType';

export const setSelectedUsagePageIndex = (index: number) => (dispatch: any) => {
  dispatchAction(dispatch, SET_SELECTED_USAGE_PAGE_INDEX, { index });
};

export const setSelectedPackageType =
  (type: EPackageType) => (dispatch: any) => {
    dispatchAction(dispatch, SET_SELECTED_SELECTED_PACKAGE_TYPE, { type });
  };

export const setBroadbandId = (id: string) => (dispatch: any) => {
  dispatchAction(dispatch, SET_BROADBAND_ID, { id });
};

export const setSelectedDailyUsageMonth =
  (index: number) => (dispatch: any) => {
    dispatchAction(dispatch, SET_SELECTED_DAILY_USAGE_MONTH, { index });
  };

export const clearUsageSummaryPageState = () => (dispatch: any) => {
  dispatchAction(dispatch, CLEAR_USAGE_SUMMARY_PAGE_STATE);
};

const dispatchAction = (dispatch: any, type: string, payload?: {}) => {
  dispatch({
    type: type,
    payload: payload,
  });
};
